import { PathOptions } from "leaflet";

export const hidrovias_fluxo_de_cabotagem = (feature: any): PathOptions => {
  return {
    color: "#0066cc",
    weight: 2.5,
    opacity: 1,
    dashArray: "8, 4",
  };
};
